"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneDeep = void 0;
var cloneDeep = function (value) {
    // Check for null or undefined values
    if (value === null || typeof value !== "object") {
        return value;
    }
    if (value instanceof Date) {
        return new Date(value.getTime());
    }
    if (value instanceof RegExp) {
        return new RegExp(value);
    }
    if (Array.isArray(value)) {
        return value.map(function (item) { return (0, exports.cloneDeep)(item); }); // Recursively clone each item in the array
    }
    var clonedObject = {};
    for (var key in value) {
        if (value.hasOwnProperty(key)) {
            clonedObject[key] = (0, exports.cloneDeep)(value[key]); // Recursively clone each property
        }
    }
    return clonedObject;
};
exports.cloneDeep = cloneDeep;
//# sourceMappingURL=utils.js.map